import React, { Fragment as _, useContext } from 'react';
import { Box } from 'theme-ui';
import { interactionContext as InteractionContext } from './interactionContext';

const AssessmentIntroduction = ({ children, ...props }) => {
  const interactionContext = useContext<any>(InteractionContext);

  const [img, text] = children;

  const { includeMedia = true } = interactionContext.props;

  return (
    <Box
      sx={{
        padding: '20px',
      }}
    >
      {includeMedia && (
        <Box
          sx={{
            margin: '20px 0',
            img: {
              maxHeight: '50vh',
            },
          }}
        >
          {img}
        </Box>
      )}

      <Box
        sx={{
          marginBottom: '20px',
        }}
      >
        {text}
      </Box>
    </Box>
  );
};

export default AssessmentIntroduction;
